import { useEffect, useRef } from 'react';
import { useAuthStore } from '../../state/auth-store';
import { identityService } from './identity-service';
import { IdentityPromptDialog } from './IdentityPromptDialog';

export function IdentityBootstrap() {
  const status = useAuthStore((state) => state.status);
  const userId = useAuthStore((state) => state.user?.id);
  const userDni = useAuthStore((state) => state.user?.dni);
  const isCheckingRef = useRef(false);

  useEffect(() => {
    if (status !== 'authenticated' || !userId || userDni || isCheckingRef.current) {
      return;
    }

    isCheckingRef.current = true;

    const timeoutId = window.setTimeout(() => {
      void identityService.ensureUserIdentification().catch((error) => {
        if (error instanceof Error && error.message === 'IDENTIFICATION_CANCELLED') {
          return;
        }

        console.error('[identity] No se pudo completar la identificacion del usuario.', error);
      }).finally(() => {
        isCheckingRef.current = false;
      });
    }, 0);

    return () => {
      window.clearTimeout(timeoutId);
      isCheckingRef.current = false;
    };
  }, [status, userDni, userId]);

  return <IdentityPromptDialog />;
}
